import _ from 'lodash';
import i18n from '@/lib/i18n';
import MENU_ITEMS from '@/constants/design/DESIGN_MENU_ITEMS';

const state = {
  menuItems: _.cloneDeep(MENU_ITEMS),
  selectedMenuItemId: ''
};

const mutations = {
  SET_SELECTED_MENU_ITEM_ID(state, selectedMenuItemId) {
    state.selectedMenuItemId = selectedMenuItemId;
  }
};

const getters = {
  selectedMenuItem: ({ selectedMenuItemId }, { menuItem }) =>
    menuItem(selectedMenuItemId),
  selectedMainMenuItem(_state, { selectedMenuItem, mainMenuItems }) {
    if (!selectedMenuItem) return;
    if (selectedMenuItem.type === 'home') return;

    if (selectedMenuItem.type !== 'main_menu') {
      return mainMenuItems.find(item => item.id === selectedMenuItem.parentId);
    } else {
      return selectedMenuItem;
    }
  },
  selectedSubMenuItem(_state, { selectedMenuItem, subMenuItems }) {
    if (!selectedMenuItem) return;

    if (selectedMenuItem.type === 'main_menu') {
      return subMenuItems(selectedMenuItem.id)[0];
    } else {
      return selectedMenuItem;
    }
  },
  selectedSubMenuItemId(_state, { selectedSubMenuItem }) {
    return selectedSubMenuItem ? selectedSubMenuItem.id : null;
  },
  homeMenuItem({ menuItems }) {
    return menuItems.find(item => item.type === 'home');
  },
  mainMenuItems(_state, { accessibleMenuItems }) {
    return accessibleMenuItems.filter(item => item.type === 'main_menu');
  },
  subMenuItems: (_state, { accessibleMenuItems }) => parentId => {
    return accessibleMenuItems.filter(item => item.parentId === parentId);
  },
  accessibleMenuItems({ menuItems }) {
    return menuItems.map(item => {
      return {
        label: i18n.t(`menu.${item.id}`),
        ...item
      };
    });
  },
  menuItem: (_state, { accessibleMenuItems }) => id => {
    return accessibleMenuItems.find(i => i.id === id);
  }
};

export default { namespaced: true, state, mutations, getters };
